export const FLM_ROUTE_MASTER_OBJECT_TYPE = 'FLM_ROUTE_MASTER';
export const FLM_ROUTE_MASTER_PARAMS = 'flm_route_master_array';

export const FLM_ROUTE_MASTER_ACTION_MAP = {
    enable: 'enable',
    disable: 'disable',
};

export const DEFAULT_ACTIONS = [
    {
        key: 'pagination',
        name: 'Pagination',
    },
    {
        key: 'perPageCountChange',
        name: 'Pagination Count',
    },
    {
        key: 'reload',
        name: 'Reload',
    },
];

export const FLM_ROUTE_LIST_COLUMNS = [ 'route_code', 'code', 'position' ];
